let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kDya6")]).then(() => parcelRequire('2FwjZ'));